/*-----------------------------------------------------------------------------/
/ Custom Theme JS - Towel to Go
/-----------------------------------------------------------------------------*/

(function () {
  'use strict';

  var STICKY_ID = 'ttgStickyCart';
  var VISIBLE_CLASS = 'ttg-sticky-cart--visible';
  var STYLE_ID = 'ttg-sticky-cart-styles';
  var syncTimer = null;

  function installStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '#' + STICKY_ID + ' {',
      '  display: none !important;',
      '  position: fixed !important;',
      '  left: 0 !important;',
      '  right: 0 !important;',
      '  bottom: 0 !important;',
      '  z-index: 9999 !important;',
      '  box-sizing: border-box !important;',
      '  padding: 10px 18px calc(10px + env(safe-area-inset-bottom)) !important;',
      '  background: var(--color--bg, #fff) !important;',
      '  box-shadow: 0 -2px 10px rgba(0,0,0,.08) !important;',
      '  pointer-events: none !important;',
      '}',
      '#' + STICKY_ID + '.' + VISIBLE_CLASS + ' { display: block !important; }',
      '#' + STICKY_ID + ' .ttg-sticky-cart__inner {',
      '  display: block !important;',
      '  width: 100% !important;',
      '  max-width: 720px !important;',
      '  margin: 0 auto !important;',
      '  padding: 0 !important;',
      '  background: transparent !important;',
      '  border: 0 !important;',
      '  box-shadow: none !important;',
      '  pointer-events: none !important;',
      '}',
      '#' + STICKY_ID + ' .ttg-sticky-cart__button {',
      '  -webkit-appearance: none !important;',
      '  appearance: none !important;',
      '  display: inline-flex !important;',
      '  align-items: center !important;',
      '  justify-content: center !important;',
      '  width: 100% !important;',
      '  min-width: 84px !important;',
      '  height: auto !important;',
      '  margin: 0 !important;',
      '  padding-top: var(--ttg-native-padding-top, 9px) !important;',
      '  padding-right: var(--ttg-native-padding-right, 30px) !important;',
      '  padding-bottom: var(--ttg-native-padding-bottom, 9px) !important;',
      '  padding-left: var(--ttg-native-padding-left, 30px) !important;',
      '  border: 0 none !important;',
      '  border-radius: var(--ttg-native-border-radius, var(--radius-button)) !important;',
      '  background-color: var(--ttg-native-background-color, var(--color--brand)) !important;',
      '  background-image: var(--ttg-native-background-image, none) !important;',
      '  color: var(--ttg-native-color, var(--color--btn)) !important;',
      '  box-shadow: var(--ttg-native-box-shadow, none) !important;',
      '  font-family: var(--ttg-native-font-family, var(--font--button)) !important;',
      '  font-size: var(--ttg-native-font-size, calc(var(--font--button-size) / var(--font--size-base) * 1rem)) !important;',
      '  font-weight: 700 !important;',
      '  font-style: var(--ttg-native-font-style, var(--font--button-style)) !important;',
      '  line-height: var(--ttg-native-line-height, 30px) !important;',
      '  letter-spacing: var(--ttg-native-letter-spacing, var(--font--button-space)) !important;',
      '  text-align: center !important;',
      '  text-transform: var(--ttg-native-text-transform, var(--font--button-transform)) !important;',
      '  cursor: pointer !important;',
      '  pointer-events: auto !important;',
      '  transition: all .2s ease-out !important;',
      '}',
      '#' + STICKY_ID + ' .ttg-sticky-cart__button:disabled { opacity: .6 !important; cursor: not-allowed !important; }',
      '#' + STICKY_ID + ' .ttg-sticky-cart__label,',
      '#' + STICKY_ID + ' .ttg-sticky-cart__separator,',
      '#' + STICKY_ID + ' .ttg-sticky-cart__price {',
      '  display: inline !important;',
      '  padding: 0 !important;',
      '  border: 0 !important;',
      '  background: transparent !important;',
      '  color: inherit !important;',
      '  font: inherit !important;',
      '  font-weight: inherit !important;',
      '  letter-spacing: inherit !important;',
      '  text-transform: inherit !important;',
      '}',
      '#' + STICKY_ID + ' .ttg-sticky-cart__label,',
      '#' + STICKY_ID + ' .ttg-sticky-cart__price { margin: 0 !important; }',
      '#' + STICKY_ID + ' .ttg-sticky-cart__separator { margin: 0 .35em !important; }',
      '@media (max-width: 47.9275em) {',
      '  #' + STICKY_ID + ' .ttg-sticky-cart__button { font-size: var(--ttg-native-font-size, var(--font--button-mobile-size)) !important; }',
      '}'
    ].join('\n');

    document.head.appendChild(style);
  }

  function getSticky() {
    return document.getElementById(STICKY_ID);
  }

  function getNativeAddButton() {
    return document.querySelector('.section--product-single .js-product-add, .section--product-single button[name="add"], product-single .js-product-add, product-single button[name="add"]');
  }

  function isElementVisible(element) {
    if (!element) return false;
    var computed = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();
    return computed.display !== 'none' && computed.visibility !== 'hidden' && computed.opacity !== '0' && rect.width > 0 && rect.height > 0;
  }

  function applyNativeButtonClasses(stickyButton, nativeButton) {
    if (!stickyButton || !nativeButton) return;

    stickyButton.className = 'ttg-sticky-cart__button';
    var hasButtonClass = false;
    var hasStyleClass = false;

    nativeButton.classList.forEach(function (className) {
      if (className === 'c-btn' || className === 'product-form__add-btn' || className.indexOf('c-btn--') === 0) {
        stickyButton.classList.add(className);
        if (className === 'c-btn') hasButtonClass = true;
        if (className.indexOf('c-btn--') === 0 && className !== 'c-btn--full') hasStyleClass = true;
      }
    });

    if (!hasButtonClass) stickyButton.classList.add('c-btn');
    if (!stickyButton.classList.contains('c-btn--full')) stickyButton.classList.add('c-btn--full');
    if (!hasStyleClass) stickyButton.classList.add('c-btn--primary');
  }

  function syncNativeAppearance(stickyButton, nativeButton) {
    if (!stickyButton || !nativeButton) return;

    applyNativeButtonClasses(stickyButton, nativeButton);

    var computed = window.getComputedStyle(nativeButton);
    var properties = {
      '--ttg-native-background-color': computed.backgroundColor,
      '--ttg-native-background-image': computed.backgroundImage,
      '--ttg-native-color': computed.color,
      '--ttg-native-box-shadow': computed.boxShadow,
      '--ttg-native-font-family': computed.fontFamily,
      '--ttg-native-font-size': computed.fontSize,
      '--ttg-native-font-style': computed.fontStyle,
      '--ttg-native-line-height': computed.lineHeight,
      '--ttg-native-letter-spacing': computed.letterSpacing,
      '--ttg-native-text-transform': computed.textTransform,
      '--ttg-native-padding-top': computed.paddingTop,
      '--ttg-native-padding-right': computed.paddingRight,
      '--ttg-native-padding-bottom': computed.paddingBottom,
      '--ttg-native-padding-left': computed.paddingLeft,
      '--ttg-native-border-radius': computed.borderRadius
    };

    Object.keys(properties).forEach(function (property) {
      if (properties[property]) stickyButton.style.setProperty(property, properties[property]);
    });
  }

  function getInitialPrice(sticky) {
    var legacyButton = sticky ? sticky.querySelector('.ttg-sticky-cart__form button') : null;
    if (!legacyButton) return '';

    var text = (legacyButton.textContent || '').replace(/\s+/g, ' ').trim();
    var index = text.lastIndexOf('•');
    return index >= 0 ? text.slice(index + 1).trim() : '';
  }

  function normalizePriceForLocale(value) {
    var price = (value || '').replace(/\s+/g, ' ').trim();
    var lang = (document.documentElement.lang || '').toLowerCase();

    if (lang.indexOf('de') === 0 && price.indexOf('€') !== -1 && /\bEUR\b/i.test(price)) {
      price = price.replace(/\s*\bEUR\b/gi, '').replace(/\s+/g, ' ').trim();
    }

    return price;
  }

  function getDisplayedPrice(nativeButton, fallbackPrice) {
    var section = nativeButton ? nativeButton.closest('.section--product-single') : null;
    if (!section) section = document.querySelector('.section--product-single');
    if (!section) return normalizePriceForLocale(fallbackPrice || '');

    var nodes = section.querySelectorAll('.price__text .money, .price__number .money');
    for (var i = 0; i < nodes.length; i += 1) {
      if (!isElementVisible(nodes[i])) continue;
      var value = normalizePriceForLocale(nodes[i].textContent || '');
      if (value) return value;
    }

    return normalizePriceForLocale(fallbackPrice || '');
  }

  function getAddToCartLabel() {
    if (window.theme && typeof window.theme.localize === 'function') {
      var translated = window.theme.localize('ADD_TO_CART');
      if (translated) return translated;
    }

    var lang = (document.documentElement.lang || '').toLowerCase();
    return lang.indexOf('de') === 0 ? 'In den Warenkorb' : 'Add to cart';
  }

  function isCartOpen() {
    return !!document.querySelector('#modal-cart[aria-hidden="false"], #popup-cart-notification[aria-hidden="false"], #modal-cart[open], #popup-cart-notification[open]');
  }

  function setStickyVisible(sticky, visible) {
    if (!sticky) return;
    if (visible) sticky.classList.add(VISIBLE_CLASS);
    else sticky.classList.remove(VISIBLE_CLASS);
  }

  function initStickyCart() {
    var sticky = getSticky();
    if (!sticky) return;

    installStyles();

    var nativeButton = getNativeAddButton();
    if (!nativeButton) {
      setStickyVisible(sticky, false);
      return;
    }

    var fallbackPrice = getInitialPrice(sticky);
    var inner = sticky.querySelector('.ttg-sticky-cart__inner');
    if (!inner) return;

    inner.innerHTML = '';

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'ttg-sticky-cart__button';

    var label = document.createElement('span');
    label.className = 'ttg-sticky-cart__label';

    var separator = document.createElement('span');
    separator.className = 'ttg-sticky-cart__separator';
    separator.setAttribute('aria-hidden', 'true');
    separator.textContent = '·';

    var price = document.createElement('span');
    price.className = 'ttg-sticky-cart__price';

    button.appendChild(label);
    button.appendChild(separator);
    button.appendChild(price);
    inner.appendChild(button);

    function syncContent() {
      var currentNativeButton = getNativeAddButton();
      if (!currentNativeButton) return;

      syncNativeAppearance(button, currentNativeButton);

      var currentPrice = getDisplayedPrice(currentNativeButton, fallbackPrice);
      if (currentPrice) fallbackPrice = currentPrice;

      label.textContent = getAddToCartLabel();
      price.textContent = currentPrice || '';
      separator.style.display = currentPrice ? 'inline' : 'none';

      var disabled = currentNativeButton.disabled || currentNativeButton.getAttribute('aria-disabled') === 'true';
      button.disabled = disabled;
      button.setAttribute('aria-label', (label.textContent + (currentPrice ? ' ' + currentPrice : '')).trim());
    }

    function refreshVisibility() {
      var currentNativeButton = getNativeAddButton();
      if (!currentNativeButton || isCartOpen()) {
        setStickyVisible(sticky, false);
        return;
      }

      var rect = currentNativeButton.getBoundingClientRect();
      var nativeInViewport = isElementVisible(currentNativeButton) && rect.top < window.innerHeight && rect.bottom > 0;
      setStickyVisible(sticky, !nativeInViewport);
    }

    function scheduleSync() {
      window.clearTimeout(syncTimer);
      syncTimer = window.setTimeout(function () {
        syncContent();
        refreshVisibility();
      }, 60);
    }

    button.addEventListener('click', function (event) {
      event.preventDefault();
      var currentNativeButton = getNativeAddButton();
      if (!currentNativeButton || currentNativeButton.disabled || currentNativeButton.getAttribute('aria-disabled') === 'true') return;

      setStickyVisible(sticky, false);
      currentNativeButton.click();
      window.setTimeout(refreshVisibility, 500);
    });

    document.addEventListener('change', scheduleSync, true);
    document.addEventListener('click', function (event) {
      if (event.target && event.target.closest && event.target.closest('.section--product-single')) scheduleSync();
    }, true);

    window.addEventListener('scroll', refreshVisibility, { passive: true });
    window.addEventListener('resize', scheduleSync, { passive: true });
    window.addEventListener('pageshow', function () {
      syncContent();
      refreshVisibility();
    });

    var productSection = nativeButton.closest('.section--product-single');
    if (productSection && window.MutationObserver) {
      var productObserver = new MutationObserver(scheduleSync);
      productObserver.observe(productSection, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class', 'style']
      });
    }

    var cartTargets = [document.getElementById('modal-cart'), document.getElementById('popup-cart-notification')];
    if (window.MutationObserver) {
      cartTargets.forEach(function (target) {
        if (!target) return;
        var cartObserver = new MutationObserver(refreshVisibility);
        cartObserver.observe(target, { attributes: true, attributeFilter: ['aria-hidden', 'open', 'class'] });
      });
    }

    syncContent();
    refreshVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyCart);
  } else {
    initStickyCart();
  }
})();

(function () {
  'use strict';

  var DE_FIRST = '4 auswählen, nur 3 bezahlen.';
  var DE_SECOND = 'Der günstigste Artikel ist gratis.';
  var EN_FIRST = 'Choose 4, pay for 3.';
  var EN_SECOND = 'The lowest-priced item is free.';

  function isGerman() {
    return (document.documentElement.lang || '').toLowerCase().indexOf('de') === 0;
  }

  function copyParts() {
    return isGerman()
      ? { first: DE_FIRST, second: DE_SECOND, full: DE_FIRST + ' ' + DE_SECOND }
      : { first: EN_FIRST, second: EN_SECOND, full: EN_FIRST + ' ' + EN_SECOND };
  }

  function normalized(value) {
    return (value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function isLegacyTitle(value) {
    var text = normalized(value);
    return text.indexOf('special offer: pay 3, get 4') !== -1 ||
      text.indexOf('special offer: 4 zahlen, 3 erhalten') !== -1;
  }

  function isLegacyBody(value) {
    var text = normalized(value);
    return text.indexOf('add 4 items to your cart – discount applied automatically') !== -1 ||
      text.indexOf('add 4 items to your cart - discount applied automatically') !== -1 ||
      text.indexOf('add 4 items to your cart – the cheapest one is on us') !== -1 ||
      text.indexOf('add 4 items to your cart - the cheapest one is on us') !== -1 ||
      text.indexOf('lege 4 artikel in den warenkorb – der günstigste ist gratis') !== -1 ||
      text.indexOf('lege 4 artikel in den warenkorb - der günstigste ist gratis') !== -1;
  }

  function isLegacyFull(value) {
    var text = normalized(value);
    return text.indexOf('pay 3 and get 4 towel to gos') !== -1 ||
      text.indexOf('pay 3 get 4: applies to all styles and colors') !== -1 ||
      text.indexOf('special offer: pay 3, get 4! add 4 products of your choice to your cart') !== -1 ||
      text === 'buy 4, pay for 3. no code needed.' ||
      text === '4 auswählen, nur 3 bezahlen. kein code nötig.';
  }

  function replaceTextNode(node) {
    if (!node || node.nodeType !== 3) return;
    var value = node.nodeValue || '';
    if (!value.trim()) return;

    var copy = copyParts();
    if (isLegacyFull(value)) {
      node.nodeValue = copy.full;
    } else if (isLegacyTitle(value)) {
      node.nodeValue = copy.first;
    } else if (isLegacyBody(value)) {
      node.nodeValue = copy.second;
    }
  }

  function processRoot(root) {
    if (!root) return;

    if (root.nodeType === 3) {
      replaceTextNode(root);
      return;
    }

    if (root.nodeType !== 1 && root.nodeType !== 9 && root.nodeType !== 11) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    var current;
    while ((current = walker.nextNode())) nodes.push(current);
    nodes.forEach(replaceTextNode);
  }

  function initPromoCopy() {
    if (!document.body) return;
    processRoot(document.body);

    if (!window.MutationObserver) return;
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData') replaceTextNode(mutation.target);
        Array.prototype.forEach.call(mutation.addedNodes || [], processRoot);
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPromoCopy);
  } else {
    initPromoCopy();
  }
})();
